import { Color } from "config/colors";
import styled from "styled-components";

export const OrgStructureEmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

type EmptyStateProps = {
  isEntity?: boolean;
};

export const OrgStructureContentContainer = styled.div<EmptyStateProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  margin-top: ${(props) => (props.isEntity ? "150px" : "0px")};
`;

export const PhoneFieldWrapper = styled.div<{ $highlighted?: boolean }>`
  & input,
  & .MuiInputBase-input {
    box-shadow: ${({ $highlighted }) =>
      $highlighted ? "0 0 0 3px rgba(25,118,210,0.25)" : "none"};
    border-radius: ${({ $highlighted }) => ($highlighted ? "8px" : "6px")};
    background-color: '#f8f9fa';
    transition: box-shadow .2s ease;
    margin-right: 60px;
  }
`;


type ModalBodyProps = {
  bigger?: boolean;
};
export const OrgStructureModalBody = styled.div<ModalBodyProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  min-width: 270px;
  width: ${(props) => (props.bigger ? "80%" : "60%")};
  height: ${(props) => (props.bigger ? "90%" : "80%")}
  max-width: ${(props) => (props.bigger ? "900px" : "600px")};
  padding: 20px 20px 30px;
  border-radius: 8px;
  background-color: ${Color.White};
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);

  p {
    margin-bottom: 30px;
  }

  .drop-down-with-label {
  margin-left: 30px;
  }
`;

export const AssignWorkersSearch = styled.div`
  max-width: 300px;
`;
export const OrgStructureWorkerModalBody = styled.div<ModalBodyProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  min-width: 270px;
  width: 850px;
  height: auto;
  max-height: 95vh;
  max-width: 95vw;
  padding: 20px 20px 30px;
  border-radius: 8px;
  background-color: ${Color.White};
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);

  p {
    margin-bottom: 30px;
  }

  .multi-select {
    margin-right: 10px;
  }
`;

export const CenteredInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  margin-bottom: 15px;
  margin-right: 0px
  justify-content: flex-end;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 15px;
  width: 100%;
  justify-content: space-between;
`;

type TabProps = {
  active: boolean;
  isDisabled?: boolean;
};

export const TabsStyled = styled.div`
  width: 60%;
  display: flex;
  justify-content: space-between;
`;

export const TabStyled = styled.div<TabProps>`
  width: 10%;
  flex-basis: 50%;
  text-align: center;
  border-bottom: ${(props) =>
    props.active
      ? `1px solid ${Color.Black}`
      : `1px solid ${Color.SeaBlue200}`};

  p:hover {
    color: ${Color.SeaBlue200};
    cursor: ${(props) => (props.isDisabled ? "auto" : "pointer")};
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

type RowProps = {
  team?: boolean;
  isInactive?: boolean;
};

export const Row = styled.div<RowProps>`
  opacity: ${(props) => (props.isInactive ? 0.6 : 1)};
  background-color: ${Color.White};
  margin: 10px 0;
  padding: 10px;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "container1 container2"
    / 1fr auto;

  border-bottom: 1px solid ${Color.SeaBlue200};

  @media (min-width: 640px) {
    grid-template:
      "container1 container2" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "container1 container2" auto
      / 2fr 2fr auto;
  }

  p {
    margin: 0;
  }
  margin-left: ${(props) => (props.team ? "40px" : "0px")};
`;

export const Container2 = styled.div`
  grid-name: container2;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DetailContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
   align-items: flex-start; 
`;

export const LastRow = styled(DetailContentContainer)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 50px;
`;

export const Column = styled(DetailContentContainer)`
  display: flex;
  flex-direction: column;
`;

export const SimpleRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 100px;
  margin-bottom: 20px;
  margin-right: 40px;
  margin-left: 10px;

  .icon {
    position: absolute;
    bottom: -10px;
    right: -10px;
  }
`;

export const WorkerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(185, 185, 185, 0.3);
`;

export const ListContainer = styled.div`
  width: 100%;
  max-height: 500px;
  overflow-y: auto;

  .checkbox-component {
    margin-top: 20px;
  }
`;

export const Container1 = styled.div`
  display: grid;
  grid-template-columns: 90px 170px 120px 200px 120px 150px;
  gap: 15px;
  align-items: center;
  width: 100%;
`;
export const ImageCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NameCell = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PhoneCell = styled.div`
  display: flex;
  align-items: center;
`;

export const EmailCell = styled.div`
  display: flex;
  align-items: center;
  word-break: break-word;
`;

export const EmploymentTypeCell = styled.div`
  display: flex;
  align-items: center;
`;

export const SalaryCell = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
`;
